import { __rest } from "tslib";
import React, { useState } from 'react';
import ScreenReaderOnlyText from "../../helpers/ScreenReaderOnlyText";
import { CTALink } from "../../ui/CTA";
import { GiftIcon, PlusIcon } from "../../ui/Icon";
import AppliedGiftCards from './components/AppliedGiftCards';
import GiftCardModal from './components/GiftCardModal';
import styles from './GiftCard.module.scss';
const GiftCard = (_a) => {
    var { labels, appliedGiftCards, removeGiftCard, trackPayWithGiftCardCTA } = _a, props = __rest(_a, ["labels", "appliedGiftCards", "removeGiftCard", "trackPayWithGiftCardCTA"]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [removedGiftCard, setRemovedGiftCard] = useState('');
    const toggleModal = (open) => {
        setIsModalOpen(open);
        if (open && trackPayWithGiftCardCTA) {
            trackPayWithGiftCardCTA();
        }
    };
    const handleRemoveGiftCard = (cardNumber) => {
        setRemovedGiftCard(cardNumber);
        removeGiftCard(cardNumber);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.giftCard },
            React.createElement(CTALink, { Tag: "button", className: styles.link, iconElement: React.createElement(GiftIcon, { size: "large" }), iconPosition: "end", onClick: toggleModal },
                React.createElement("span", { className: styles.text },
                    React.createElement(PlusIcon, { size: "small", className: styles.plusIcon }),
                    labels.addGiftCardText)),
            React.createElement("div", { "aria-live": "polite" },
                React.createElement(ScreenReaderOnlyText, null, `${labels.heading} ${removedGiftCard} ${labels.removed}`)),
            appliedGiftCards.length > 0 && (React.createElement(AppliedGiftCards, { appliedGiftCards: appliedGiftCards, labels: labels, removeGiftCard: handleRemoveGiftCard }))),
        React.createElement(GiftCardModal, Object.assign({ labels: labels, isModalOpen: isModalOpen, toggleModal: toggleModal }, props))));
};
export default GiftCard;
//# sourceMappingURL=GiftCard.js.map